import { connect } from 'formik'
import PropTypes from 'prop-types'
import { Component } from 'react'

class Effect extends Component<any, any> {
  static displayName = 'Effect'

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    formik: PropTypes.object.isRequired
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps: any) {
    const { values } = this.props.formik
    const { values: nextValues } = nextProps.formik
    if (nextProps.formik !== this.props.formik && nextValues !== values) {
      this.props.onChange(nextValues, nextProps.formik)
    }
  }

  render() {
    return null
  }
}

export default connect(Effect)
